import type { Move } from '../domain/chess/ChessRules';

export function LastMove({ move }: { move?: Move }) {
  return (
    <div className="last-move" data-testid="last-move" aria-live="polite">
      {move && (
        <>
          <span className="sr-only">Previous move: {move.color === 'w' ? 'White' : 'Black'} </span>
          <span className="move-number">
            {move.before.split(' ')[5]}
            {move.color === 'b' ? '…' : '.'}
          </span>
          <strong>{move.san}</strong>
          <span className="move-route">
            {move.from} → {move.to}
          </span>
        </>
      )}
    </div>
  );
}
